import en from './locales/en.js';
import de from './locales/de.js';
import es from './locales/es.js';
import fr from './locales/fr.js';
import it from "./locales/it.js";

const messages = {
    en,
    de,
    es,
    fr,
    it,
};

export default messages;